import DisplayItem from '@/models/DisplayItem';
import ITestReviewDisplayStrategy from './ITestReviewDisplayStrategy';

class TestReviewDisplayStrategy implements ITestReviewDisplayStrategy {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getText(adjustedDisplayItems: Array<DisplayItem>): string {
    return '';
  }

  getDisplayHeight(hidden: boolean): string {
    return this.calculateDisplayHeight(hidden) + 'px';
  }

  isScreenDisplay(): boolean {
    return false;
  }

  createStyle(): Map<string, string> {
    const map: Map<string, string> = new Map<string, string>();

    map['width'] = '90%';
    map['position'] = 'absolute';
    map['top'] = '1px';
    map['border-bottom-left-radius'] = '4px';
    map['border-bottom-right-radius'] = '4px';
    map['margin-left'] = '20px';
    map['margin-right'] = '20px';
    map['transition-property'] = 'height';
    map['transition-duration'] = '350ms';
    map['will-change'] = 'filter';
    map['filter'] = 'drop-shadow(2px 2px 2px gray)';

    return map;
  }

  private calculateDisplayHeight(hidden: boolean): number {
    if (hidden) {
      return 0;
    } else {
      const filterTitleContainer: HTMLElement | null = document.getElementById('filter-title-container');
      const buttonContainer: HTMLElement | null = document.getElementById('button-container');

      let filterHeight = 150;
      if (filterTitleContainer && buttonContainer) {
        filterHeight += filterTitleContainer.clientHeight + buttonContainer.clientHeight;
      }
      return Math.max(
        filterHeight,
        Math.min(document.getElementById('inner-question-container')!.clientHeight + 150, window.innerHeight - 136)
      );
    }
  }
}

export default TestReviewDisplayStrategy;
